/**
 * jQuery 4.x native shims for extra compatibility with third party scripts
 */

import {$} from 'jquery/slim';

const class2type = {};

'Boolean Number String Function Array Date RegExp Object'.split(' ').forEach(name => {
  class2type[`[object ${name}]`] = name.toLowerCase();
});


$.type = function (obj) {
  if (obj == null) {
    return obj + '';
  }
  return typeof obj === 'object' || typeof obj === 'function' ? class2type[toString.call(obj)] || 'object' : typeof obj;
}

export default $;
